<template>
  <div class="mc-delivery-track-sidebar-accordion-item">
    <div header-tag="header" role="tab">
      <div v-b-toggle.accordion-5 class="d-flex justify-content-between">
        <h5>{{ 'Riwayat Pengiriman' }}</h5>
        <div>
          <i class="mc-fa icon-fill_arrow-ios-down"></i>
          <i class="mc-fa icon-fill_arrow-ios-up"></i>
        </div>
      </div>
    </div>
    <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
      <div class="mc-delivery-track-sidebar-history">
        <div
          v-for="(item, index) in data"
          :key="index"
          class="mc-delivery-track-sidebar-history-item clearfix"
        >
          <div class="mc-delivery-track-sidebar-history-item-line">
            <i class="mc-fa icon-outline_arrow-circle-right"></i>
          </div>
          <div class="mc-delivery-track-sidebar-history-item-detail">
            <b-skeleton-wrapper :loading="isLoading">
              <template #loading>
                <b-skeleton width="90%" />
                <b-skeleton width="70%" />
                <b-skeleton width="70%" />
                <b-skeleton width="60%" />
                <b-skeleton width="50%" />
                <b-skeleton width="60%" />
              </template>
              <p style="grid-area: history-date">
                {{ formatIndexDate(item.created_on).date }}
              </p>
              <span class="text-muted" style="grid-area: history-time">{{
                formatIndexDate(item.created_on).time
              }}</span>
              <div style="grid-area: history-detail">
                <p>{{ item.title }}</p>
                <div class="text-muted">
                  <span>{{ item.description }}</span>
                  <span
                    v-for="property in item.properties"
                    :key="`${property.key}-${property.value}`"
                  >
                    <div
                      v-if="
                        !property.key.toLowerCase().includes('delivery_order_uuid') &&
                        !property.key.toLowerCase().includes('delivery_load_log_uuid')
                      "
                    >
                      <span> {{ property.key }}: {{ property.value }} </span>
                    </div>
                  </span>
                </div>
              </div>
            </b-skeleton-wrapper>
          </div>
        </div>
        <div class="mc-delivery-track-sidebar-history-item clearfix">
          <div class="mc-delivery-track-sidebar-history-item-line">
            <i class="mc-fa icon-fill_radio-button-on"></i>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { formatIndexDate } from '@/helpers/tzDate'

export default {
  props: {
    data: {
      type: Array,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isLoading() {
      return this.loading
    },
  },

  methods: {
    formatIndexDate,
  },
}
</script>
